<script setup lang="ts">
  import { computed } from 'vue';
  import { HoverListTooltip } from '@/shared/ui';
  import type { NotificationUser } from '@/shared/lib';

  const props = defineProps<{
    recipients: NotificationUser[];
  }>();

  const label = computed(
    () => `${props.recipients.length} colaborador${props.recipients.length !== 1 ? 'es' : ''}`
  );

  const title = computed(
    () => `Colaborador${props.recipients.length !== 1 ? 'es' : ''} (${props.recipients.length})`
  );

  const items = computed(() =>
    props.recipients.map((recipient) => ({ id: recipient.id, text: recipient.name }))
  );
</script>

<template>
  <HoverListTooltip
    :label="label"
    :title="title"
    :items="items"
    test-id="collaborators-tooltip"
  />
</template>
